import {API_PATH, HTTP_OK} from '@app/common/constants';
import NetworkService from '@app/services/network/NetworkService';
import {call, put, takeLatest} from '@redux-saga/core/effects';
import {select} from 'redux-saga/effects';
import {appSelector} from '@app/store/selectors';
import {zhoTransferStateActions, executeZhoTransferCreatorTypeName} from './slice';

export function* executeZhoTransferWatcher() {
  yield takeLatest(executeZhoTransferCreatorTypeName, executeZhoTransferWorker);
}

export function* executeZhoTransferWorker(action: any): any {
  try {
    yield put(zhoTransferStateActions.setIsTransferring(true));
    const userInfo = yield select(appSelector.getUserInfo());
    const request = {
      fromSapCode: action.payload?.fromSapCode,
      toSapCode: action.payload?.toSapCode,
      createdBy: userInfo?.userId || 0,
    };
    const url = API_PATH.zho.zhoTransfer.executeTransfer;
    const response = yield call(NetworkService.post, url, request);

    const isError =
      response?.data?.isError === true || response?.data?.isError === 'true';

    if (response?.status === HTTP_OK && !isError) {
      yield put(
        zhoTransferStateActions.setZhoTransferListData(
          response?.data?.response,
        ),
      );
      yield put(
        zhoTransferStateActions.setExecuteTransferResponse({
          success: true,
          message: 'Transfer completed successfully.',
        }),
      );
    } else {
      yield put(zhoTransferStateActions.setHasResults(false));
      yield put(
        zhoTransferStateActions.setExecuteTransferResponse({
          success: false,
          message:
            response?.data?.errorMessage ||
            response?.data?.details?.[0]?.message ||
            'Something went wrong.',
        }),
      );
    }
  } catch (error) {
    yield put(zhoTransferStateActions.setHasResults(false));
    yield put(
      zhoTransferStateActions.setExecuteTransferResponse({
        success: false,
        message: 'Something went wrong.',
      }),
    );
  } finally {
    yield put(zhoTransferStateActions.setIsTransferring(false));
  }
}
